import { render, staticRenderFns } from "./paneldynamic.vue?vue&type=template&id=9dda5d06&"
import script from "./paneldynamic.vue?vue&type=script&lang=ts&"
export * from "./paneldynamic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dda5d06')) {
      api.createRecord('9dda5d06', component.options)
    } else {
      api.reload('9dda5d06', component.options)
    }
    module.hot.accept("./paneldynamic.vue?vue&type=template&id=9dda5d06&", function () {
      api.rerender('9dda5d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/paneldynamic.vue"
export default component.exports